import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button, Alert, useTheme, useMediaQuery } from '@mui/material';

const SecurityModal = ({ open, onClose, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Senhas e perfis
  const passwords = {
    empresa: "Theo17",
    pessoal: ["Zion23", "Teste123"]
  };

  const handleSubmit = () => {
    const normalizedInput = password.replace(/\s+/g, ' ').trim();

    if (!normalizedInput) {
      setError('Por favor insira uma senha');
      return;
    }

    // Verifica perfil
    let perfil = null;
    if (normalizedInput === passwords.empresa) {
      perfil = "empresa";
    } else if (passwords.pessoal.includes(normalizedInput)) {
      perfil = "pessoal";
    }

    if (perfil) {
      onSuccess(perfil);
      onClose();
    } else {
      setError('Senha incorreta');
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Modal open={open} onClose={onClose} sx={{ backdropFilter: 'blur(10px)' }}>
      <Box sx={{ 
        p: isMobile ? 3 : 4, 
        bgcolor: 'background.paper', 
        borderRadius: 2, 
        boxShadow: 24, 
        maxWidth: isMobile ? '90%' : 400, 
        mx: 'auto', 
        mt: isMobile ? '10%' : '20%',
        width: isMobile ? '90%' : 'auto'
      }}>
        <Typography variant={isMobile ? "h6" : "h6"} gutterBottom sx={{ textAlign: 'center' }}>
          Digite a senha de segurança
        </Typography>
        
        {error && (
          <Alert severity="error" sx={{ mb: 2, fontSize: isMobile ? '0.875rem' : '1rem' }}>
            {error}
          </Alert>
        )}
        
        <TextField
          fullWidth
          type="password"
          label="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ mb: 3 }}
          size={isMobile ? "small" : "medium"}
        />
        
        <Button 
          variant="contained" 
          fullWidth 
          onClick={handleSubmit}
          size={isMobile ? "medium" : "large"}
          sx={{ 
            py: isMobile ? 1 : 1.5,
            fontSize: isMobile ? '0.875rem' : '1rem'
          }}
        >
          Confirmar
        </Button>
      </Box>
    </Modal>
  );
};

export default SecurityModal;
